import { useEffect, useRef } from "react";

const useTimeoutedEffect = (
  effect: () => void | Promise<void> | (() => void),
  deps?: React.DependencyList,
  timeout?: number,
) => {
  const timeoutId = useRef<NodeJS.Timeout>(null);
  useEffect(() => {
    timeoutId.current && clearTimeout(timeoutId.current);
    timeoutId.current = setTimeout(effect, timeout);
  }, deps)
}

export default useTimeoutedEffect;